import { StoreState } from "@/redux/RootReducer";
import { AdminTargetState, ProgressState } from "./reducers";

export const adminTargetSelectors = {
  getState: (state: StoreState): AdminTargetState => state.adminTarget,
  getProgress: (state: StoreState): ProgressState => state.adminTarget.progress,
};
